###
  Показывает всплывающее сообщение
###

class INTENT.utils.Notify

  @default_options: {
    auto_hide: on
    closable: on
    fadeOut:
      enabled: on
      delay: 3000
    type: 'info'
    classElement: '.notifications.bottom-right-col'
    message:
      html: '...'
  }

  @message: (text, type, options={}) =>
    options = $.extend({}, @default_options, options)
    options.message.html = text.split("\n").join('<br>');
    options.type = type

    if not options.auto_hide
      options.fadeOut.enabled = no
      delete options.auto_hide

    $(options.classElement).notify(options).show();

  @top_message: (text, type) =>
    text = text.split("\n").join('<br>');
    alert = """
    <div class="alert alert-dismissible alert-no-dismiss alert-#{type} generated-top-alert">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button>
      #{text}
    </div>
    """
    container = $('.main .container-fluid')
    container.find('.generated-top-alert').remove()
    container.prepend(alert)

  @success: (text, options={}) ->
    @message text, 'success', options

  @info: (text, options={}) ->
    @message text, 'info', options

  @warning: (text, options={}) ->
    @message text, 'warning', options

  @danger: (text, options={}) ->
    @message text, 'danger', options

  @error: (text, options={}) ->
    @danger text, options
